@use "../../helpers/tableStyles/TableStyles.scss";

@use "variables" as *;

.wrapperDesktop {
  height: TableStyles.$table-body-height;
  padding: $spacing-2;
}

.skeletonDesktop {
  width: 100%;
  margin-bottom: $spacing-2;
  height: 72px;
  background-color: rgba(200, 200, 200, 1);

  &:nth-of-type(2) {
    background-color: rgba(200, 200, 200, 0.9);
  }
  &:nth-of-type(3) {
    background-color: rgba(200, 200, 200, 0.75);
  }
  &:nth-of-type(4) {
    background-color: rgba(200, 200, 200, 0.6);
  }
  &:nth-of-type(5) {
    background-color: rgba(200, 200, 200, 0.5);
  }
  &:nth-of-type(6) {
    background-color: rgba(200, 200, 200, 0.35);
  }
  &:nth-of-type(7) {
    background-color: rgba(200, 200, 200, 0.2);
  }
}
